export default class PageHelper {
  static topFunction() {
    let currentYOffset = self.pageYOffset;
    let initYOffset = currentYOffset;

    var intervalId = setInterval(function () {
      currentYOffset -= initYOffset * 0.05;
      document.body.scrollTop = currentYOffset;
      document.documentElement.scrollTop = currentYOffset;

      if (self.pageYOffset == 0) {
        clearInterval(intervalId);
      }
    }, 20);
  }
}
